import { render } from "./classroom-assignment.vue?vue&type=template&id=1fadea64"
import script from "./classroom-assignment.vue?vue&type=script&lang=ts"
export * from "./classroom-assignment.vue?vue&type=script&lang=ts"
script.render = render

export default script